import type { ReactNode } from 'react'
import { createContext, useContext, useState } from 'react'

type Language = 'pt' | 'en'

interface Translations {
  [key: string]: { pt: string, en: string }
}

const dict: Translations = {
  'nav.home': { pt: 'Início', en: 'Home' },
  'nav.about': { pt: 'Sobre Nós', en: 'About Us' },
  'nav.services': { pt: 'Serviços', en: 'Services' },
  'nav.portfolio': { pt: 'Portfólio', en: 'Portfolio' },
  'nav.blog': { pt: 'Blog', en: 'Blog' },
  'nav.careers': { pt: 'Carreiras', en: 'Careers' },
  'nav.resources': { pt: 'Recursos', en: 'Resources' },
  'nav.events': { pt: 'Eventos', en: 'Events' },
  'nav.contact': { pt: 'Contato', en: 'Contact' },
  'nav.cta': { pt: 'Solicitar Consultoria', en: 'Request Consultation' },
  'search.placeholder': { pt: 'Buscar serviços, projetos, artigos...', en: 'Search services, projects, articles...' },
  'search.noResults': { pt: 'Nenhum resultado encontrado.', en: 'No results found.' },
  'footer.rights': { pt: 'Todos os direitos reservados.', en: 'All rights reserved.' },
  'footer.privacy': { pt: 'Política de Privacidade', en: 'Privacy Policy' },
  'newsletter.title': { pt: 'Receba nossas novidades', en: 'Get our updates' },
  'newsletter.placeholder': { pt: 'Seu e-mail corporativo', en: 'Your business email' },
  'newsletter.button': { pt: 'Assinar', en: 'Subscribe' },
  'chat.title': { pt: 'Fale com um especialista', en: 'Talk to a specialist' },
}

interface LanguageContextValue {
  language: Language
  setLanguage: (lang: Language) => void
  t: (key: string) => string
}

const LanguageContext = createContext<LanguageContextValue | undefined>(undefined)

export function LanguageProvider({ children }: { children: ReactNode }) {
  const [language, setLanguage] = useState<Language>('pt')

  const t = (key: string) => dict[key]?.[language] ?? key

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  )
}

export function useLanguage() {
  const ctx = useContext(LanguageContext)
  if (!ctx)
    throw new Error('useLanguage must be used within LanguageProvider')
  return ctx
}
